/** @file Translate tool registration: title and activation chord W (viewport context). */
import type { ToolDef } from '../../stores/types';

/** Moves the selected bones (setup values or keys). */
export const tool: ToolDef = { id: 'translate', title: 'tools.translate.title', bindings: [{ id: 'tool.translate', keys: 'KeyW', context: 'viewport' }] };
